import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    status: false, // 是否获取公共数据
    pageInit: {
        recommended: {},                                                                // 中台页面缓存
        SEOChecker: {},                                                                 // SEO Checker
        SiteSpeedUp: {},                                                                // 加速页面
        ImageOptimization: null,                                                        // 图片压缩
        AmpData: null,                                                                  // AMP
        GoogleAnalytics: null,                                                          // 谷歌分析登录
        MetaTags: null,                                                                 // 元标签元描述页面缓存
        InstantIndex: null,                                                             // 及时索引
        ExchangeBacklink: {}, //外链互换
        onPage: {},                                                                     // onpage页面缓存 
        htmlSitemap: {
            isResetLoading: false,                                                      // 页面btn-loading
            getStructuredData: {}
        },                                                                              // html站点地图页面缓存
        speedAnalysis: {},                                                              // speed页面缓存
        jsonLD: {},                                                                     // jsonLD页面缓存
        integration: {
            isResetLoading: false,                                                      // 页面btn-loading
            getShopifyPrimary: {}
        },                                                                              // 功能集合页面缓存
        pricingPlan: null,                                                              // 价格页面缓存
    },
}

export const pageData = createSlice({
    name: 'public',
    initialState,
    reducers: {
        // 设置页面loading状态 首次访问页面loading 并缓存接口值
        setPageData: (state, action) => {
            if (['SiteSpeedUp', 'speedAnalysis', 'ExchangeBacklink', 'SEOChecker'].includes(action.payload[0])) { // 速度分析页面相关缓存
                let key = Object.keys(action.payload[1])[0]
                if (Object.keys(action.payload[1]).includes(key)) {
                    // 追加多个接口到对象中
                    state.pageInit[action.payload[0]][key] = action.payload[1][key]
                }
            } else if (action.payload[0] === 'integration' || action.payload[0] === 'htmlSitemap') { // 功能集成页面 htmlSitemap 相关缓存
                state.pageInit[action.payload[0]] = action.payload[1]
                state.pageInit[action.payload[0]]['isResetLoading'] = true;
            } else {
                state.pageInit[action.payload[0]] = action.payload[1]
            }
        },

        // 设置页面按钮loading
        setPageLoading: (state, action) => {
            if (action.payload[0] === 'integration' || action.payload[0] === 'htmlSitemap') {
                state.pageInit[action.payload[0]]['isResetLoading'] = false;
            }
        },

    },
})


// Action creators are generated for each case reducer function
// 为每个case reducer函数生成动作创建者
export const {
    setPageData,
    setPageLoading,
} = pageData.actions

// selector 函数允许我们从 state 中获取值
// Selectors 也可以在使用的地方内联的方式定义
// 而不是仅仅只能在 slice 文件中。例如 : `useSelector((state) => state.counter.value)`
export const selectPublicData = state => state.public

export default pageData.reducer